import { RootState } from 'data';

export const getSelectedTasks = ({ sprints }: RootState): number[] =>
  sprints.selectedTasks;

export const getIsSprintDirty = ({ sprints }: RootState): boolean =>
  sprints.isDirty;
